export default __webpack_public_path__ + "static/media/trackdays-1.dba31381.jpg";